import { ca } from '@cian/analytics';
import { ITrackingExtra } from '../Notification';

export function trackingNotificationIconClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'icon',
  });
}

export function trackingNotificationClick(withPush: boolean, extra: ITrackingExtra) {
  const page = window && window.CianAnalytics ? window.CianAnalytics.service.config.page : {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: withPush ? 'read_push' : 'read_not_push',
    page: {
      ...page,
      extra,
    },
  });
}

export function trackingDeleteAllClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'delete_all',
  });
}

export function trackingMarkAllAsRead() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'read_all',
  });
}

export function trackingSettingsIconClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'settings',
  });
}

export function trackingShowEmptyScreen() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Show',
    label: 'empty_screen',
  });
}

export function trackingShowSubscribeNotifications() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Subscription',
    action: 'Show',
    label: 'notification_banner',
  });
}

export function trackingClickSubscribeNotifications() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Subscription',
    action: 'Send',
    label: 'notification_banner',
  });
}
